import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import CheckIn from "@/pages/CheckIn";
import Plan from "@/pages/Plan";
import Evidence from "@/pages/Evidence";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import Method from "@/pages/Method";
import Safety from "@/pages/Safety";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-bone text-ink">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/check-in" element={<CheckIn />} />
          <Route path="/plan/:id" element={<Plan />} />
          <Route path="/evidence" element={<Evidence />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightArticle />} />
          <Route path="/method" element={<Method />} />
          <Route path="/safety" element={<Safety />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-center" toastOptions={{ style: { background: "#0B2530", color: "#F7F3EA", border: "1px solid rgba(247,243,234,0.15)" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
